function get_timezone() {
    if (document.cookie.indexOf('ct_email') > -1) {
        var x = new Date();
        var currentTimeZoneOffsetInHours = -x.getTimezoneOffset() / 60;

        // Mootols style
        if (typeof Cookie !== "undefined") {
            Cookie.write('ct_user_timezone', currentTimeZoneOffsetInHours);
        }

        // jQuery style
        if ($.cookie) {
            $.cookie("ct_user_timezone", currentTimeZoneOffsetInHours);
            result = $.get("/my/ajax", {action: "update_timezone", timezone: currentTimeZoneOffsetInHours});
        }
    }

	return true;
}
get_timezone();
